import { gql } from '@apollo/client'

import { INVENTORY_ORDER_ITEM_FIELDS } from '../fragments'

export const ADD_INVENTORY_ORDER_ITEM_RECEIPTS = gql`
  ${INVENTORY_ORDER_ITEM_FIELDS}
  mutation AddInventoryOrderItemReceipts(
    $input: AddInventoryOrderItemReceiptsInput!
  ) {
    addInventoryOrderItemReceipts(input: $input) {
      ...InventoryOrderItemFields
    }
  }
`
